import { graphql, useStaticQuery } from '@amazeelabs/gatsby-plugin-operations';
import { SettingsCallToActionQuery } from '@custom/schema';

export const useSettingsCallToActionQuery = () =>
  useStaticQuery(graphql(SettingsCallToActionQuery));
